export enum MATERIAL_TYPES {
  ROCK = "ROCK",
  PAPER = "PAPER",
  SCISSOR = "SCISSOR",
  LIZARD = "LIZARD",
  SPOCK = "SPOCK",
}
